export default {
    dependencies: {
      'linear-gradient': require('expo-linear-gradient').LinearGradient,
    },
  };